// Simple Select Component (beze změny - původní logika)
export class SimpleCartSelect {
    private static isInitialized: boolean = false;

    static init(): void {
        this.simpleCartSelectInit();
    }

    private static simpleCartSelectInit(): void {
        const initSimpleCartSelects = (): void => {
            const selectContainers: NodeListOf<Element> = document.querySelectorAll('.select-container-simple');

            if (selectContainers.length === 0) {
                return;
            }

            selectContainers.forEach((container: Element) => {
                const customSelect: Element | null = container.querySelector('.simple-cart-select');
                const selectOptions: Element | null = container.querySelector('.cart-select-options');
                const options: NodeListOf<Element> = container.querySelectorAll('.simple-select-option');

                if (!customSelect || !selectOptions) return;

                // Toggle dropdown
                customSelect.addEventListener('click', (e: Event) => {
                    e.stopPropagation();
                    closeAllDropdowns();

                    const isActive: boolean = customSelect.classList.contains('active');
                    if (!isActive) {
                        openDropdown(customSelect, selectOptions);
                    }
                });

                // Handle option selection
                options.forEach((option: Element) => {
                    option.addEventListener('click', (e: Event) => {
                        e.stopPropagation();

                        options.forEach((opt: Element) => opt.classList.remove('selected'));
                        option.classList.add('selected');

                        const selectText: Element | null = customSelect.querySelector('.simple-select-text');
                        const optionText: Element | null = option.querySelector('.simple-select-text');

                        if (selectText && optionText) {
                            selectText.textContent = optionText.textContent;
                        }

                        closeDropdown(customSelect, selectOptions);
                    });
                });
            });
        };

        const closeAllDropdowns = (): void => {
            const allSelects: NodeListOf<Element> = document.querySelectorAll('.simple-cart-select');
            const allOptions: NodeListOf<Element> = document.querySelectorAll(
                '.select-container-simple .cart-select-options',
            );

            allSelects.forEach((select: Element) => select.classList.remove('active'));
            allOptions.forEach((options: Element) => options.classList.remove('show'));
        };

        const openDropdown = (select: Element, options: Element): void => {
            select.classList.add('active');
            options.classList.add('show');
        };

        const closeDropdown = (select: Element, options: Element): void => {
            select.classList.remove('active');
            options.classList.remove('show');
        };

        const handleOutsideClick = (): void => {
            closeAllDropdowns();
        };

        const handleKeydown = (e: KeyboardEvent): void => {
            if (e.key === 'Escape') {
                closeAllDropdowns();
            }
        };

        const hasSelects = document.querySelector('.select-container-simple') !== null;
        if (hasSelects) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleKeydown);
        }

        initSimpleCartSelects();
    }
}

// Pricing Select Component (úplně nový s custom input)
export class PricingCartSelect {
    private static instances: PricingSelectInstance[] = [];

    static init(): void {
        this.pricingCartSelectInit();
    }

    private static pricingCartSelectInit(): void {
        const selectContainers: NodeListOf<Element> = document.querySelectorAll('.select-container');

        if (selectContainers.length === 0) {
            return;
        }

        // Clear previous instances
        this.instances = [];

        selectContainers.forEach((container: Element) => {
            const instance = new PricingSelectInstance(container as HTMLElement);
            this.instances.push(instance);
        });

        // Global click handler
        document.addEventListener('click', this.handleGlobalClick);
        document.addEventListener('keydown', this.handleGlobalKeydown);
    }

    private static handleGlobalClick = (e: Event): void => {
        const target = e.target as Element;

        // Check each instance
        this.instances.forEach((instance) => {
            const clickedInsideThisSelect = target.closest('.select-container') === instance.getContainer();

            if (!clickedInsideThisSelect && instance.getIsOpen()) {
                // Clicked outside this select - check if input has value
                const customInput = instance.getCustomInput();
                if (customInput && customInput.value.trim() !== '') {
                    // Apply the custom quantity before closing
                    instance.applyCustomQuantity();
                } else {
                    // Just close normally
                    instance.forceClose();
                }
            }
        });
    };

    private static handleGlobalKeydown = (e: KeyboardEvent): void => {
        if (e.key === 'Escape') {
            this.instances.forEach((instance) => instance.forceClose());
        }
    };

    static destroy(): void {
        document.removeEventListener('click', this.handleGlobalClick);
        document.removeEventListener('keydown', this.handleGlobalKeydown);
        this.instances.forEach((instance) => instance.destroy());
        this.instances = [];
    }
}

class PricingSelectInstance {
    private container: HTMLElement;
    private header: HTMLElement;
    private selectedValue: HTMLElement;
    private arrow: HTMLElement;
    private options: HTMLElement;
    private optionElements: NodeListOf<HTMLElement>;
    private customInput: HTMLInputElement | null = null;
    private isOpen: boolean = false;
    private inputIsFocused: boolean = false;
    private currentCustomQuantity: number | null = null; // Store current custom quantity
    private quantityPricingData: any = null;

    constructor(container: HTMLElement) {
        this.container = container;

        // Get elements
        this.header = container.querySelector('.select-header') as HTMLElement;
        this.selectedValue = container.querySelector('.selected-value') as HTMLElement;
        this.arrow = container.querySelector('.select-arrow') as HTMLElement;
        this.options = container.querySelector('.select-options') as HTMLElement;
        this.optionElements = container.querySelectorAll('.option') as NodeListOf<HTMLElement>;
        this.customInput = container.querySelector('.custom-quantity-input') as HTMLInputElement;

        // Load quantity pricing data
        const pricingDataScript = container.querySelector('.quantity-pricing-data');
        if (pricingDataScript && pricingDataScript.textContent) {
            try {
                this.quantityPricingData = JSON.parse(pricingDataScript.textContent);
            } catch (e) {
                console.warn('Failed to parse quantity pricing data:', e);
            }
        }

        if (!this.header || !this.selectedValue || !this.arrow || !this.options) {
            throw new Error('PricingSelect: Missing required elements');
        }

        this.init();
        this.initializeDisplay();
    }

    private init(): void {
        // Header click to toggle
        this.header.addEventListener('click', this.handleHeaderClick);

        // Options click
        this.optionElements.forEach((option: HTMLElement) => {
            if (option.classList.contains('custom-input-option')) {
                this.initCustomInputOption(option);
            } else {
                option.addEventListener('click', () => this.selectOption(option));
            }
        });

        // Arrow rotation
        this.header.setAttribute('tabindex', '0');
    }

    private initializeDisplay(): void {
        // Check if current quantity matches any predefined option
        const hiddenInput = this.container.querySelector('.cart-quantity-input') as HTMLInputElement;
        if (!hiddenInput) return;

        const currentQuantity = parseInt(hiddenInput.value, 10);
        if (isNaN(currentQuantity)) return;

        // Check if there's a fallback display (indicates custom quantity)
        const fallbackSpan = this.selectedValue.querySelector('.selected-quantity-fallback');
        if (fallbackSpan && this.quantityPricingData) {
            // This is a custom quantity that needs pricing calculation
            this.currentCustomQuantity = currentQuantity;
            const pricing = this.calculatePricingForQuantity(currentQuantity);
            
            if (pricing) {
                const priceText = pricing.pricePerUnit > 0 ? `${pricing.pricePerUnit.toFixed(2).replace('.', ',')} Kč/ks` : 'Na vyžádání';
                const discountText = pricing.discount > 0 ? `Ušetříte ${Math.round(pricing.discount)} %` : '';
                
                // Replace the fallback span with proper pricing structure
                fallbackSpan.outerHTML = `<div class="selected-wrapper"><div class="selected-quantity">${currentQuantity} ks</div><div class="selected-price">${priceText}</div>${discountText ? `<div class="selected-discount">${discountText}</div>` : ''}</div>`;
            }
            return;
        }

        // Alternative check: if no wrapper exists but we have pricing data, check if it's a custom quantity
        if (!this.selectedValue.querySelector('.selected-wrapper') && this.quantityPricingData) {
            // Check if current quantity matches any predefined option
            let matchedOption = false;
            this.optionElements.forEach((option: HTMLElement) => {
                if (option.classList.contains('custom-input-option')) return;
                
                const optionValue = parseInt(option.dataset.value || '0', 10);
                if (optionValue === currentQuantity) {
                    matchedOption = true;
                }
            });

            // If no match found, it's a custom quantity - calculate and display pricing
            if (!matchedOption) {
                this.currentCustomQuantity = currentQuantity;
                const pricing = this.calculatePricingForQuantity(currentQuantity);
                
                if (pricing) {
                    const priceText = pricing.pricePerUnit > 0 ? `${pricing.pricePerUnit.toFixed(2).replace('.', ',')} Kč/ks` : 'Na vyžádání';
                    const discountText = pricing.discount > 0 ? `Ušetříte ${Math.round(pricing.discount)} %` : '';
                    
                    // Find and replace the content that's not the hidden input
                    const hiddenInput = this.selectedValue.querySelector('.cart-quantity-input');
                    if (hiddenInput) {
                        this.selectedValue.innerHTML = '';
                        this.selectedValue.appendChild(hiddenInput);
                        this.selectedValue.insertAdjacentHTML('beforeend', `<div class="selected-wrapper"><div class="selected-quantity">${currentQuantity} ks</div><div class="selected-price">${priceText}</div>${discountText ? `<div class="selected-discount">${discountText}</div>` : ''}</div>`);
                    }
                }
            }
        }
    }

    private handleHeaderClick = (e: Event): void => {
        e.stopPropagation();

        // Close other instances
        const instances = (PricingCartSelect as any).instances as PricingSelectInstance[];
        instances.forEach((instance) => {
            if (instance !== this) {
                instance.forceClose();
            }
        });

        this.toggle();
    };

    private initCustomInputOption(option: HTMLElement): void {
        if (!this.customInput) return;

        // Handle clicks on the option (but not the input)
        option.addEventListener('click', (e: Event) => {
            const target = e.target as Element;
            if (target === this.customInput || target.closest('.custom-quantity-input')) {
                return; // Let input handle its own clicks
            }

            e.stopPropagation();
            if (this.customInput) {
                this.customInput.focus();
            }
        });

        // Handle input events
        this.customInput.addEventListener('click', (e: Event) => {
            e.stopPropagation(); // Prevent option click
        });

        this.customInput.addEventListener('focus', () => {
            this.inputIsFocused = true;
            option.classList.add('focused');
        });

        this.customInput.addEventListener('blur', () => {
            setTimeout(() => {
                this.inputIsFocused = false;
                option.classList.remove('focused');
                // Removed auto-apply on blur - now handled by global click handler
            }, 100);
        });

        this.customInput.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.applyCustomQuantity();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                this.forceClose(); // Use forceClose for Escape too
            }
        });

    }

    private selectOption(option: HTMLElement): void {
        // Remove selected from all options
        this.optionElements.forEach((opt) => opt.classList.remove('selected'));

        // Add selected to clicked option
        option.classList.add('selected');

        // Clear custom quantity since we selected a regular option
        this.currentCustomQuantity = null;

        // Update display
        const quantityElement = option.querySelector('.option-quantity');
        const priceElement = option.querySelector('.option-price');
        const discountElement = option.querySelector('.option-discount');

        if (quantityElement && discountElement && priceElement) {
            const quantity = quantityElement.textContent;
            const price = priceElement.textContent;
            const discount = discountElement.textContent;
            this.selectedValue.innerHTML = `<div class="selected-wrapper"><div class="selected-quantity">${quantity}</div><div class="selected-price">${price}</div><div class="selected-discount">${discount}</div></div>`;
        } else {
            this.selectedValue.textContent = option.innerHTML || '';
        }

        // Dispatch event
        const changeEvent = new CustomEvent('pricingSelectChange', {
            detail: {
                value: option.dataset.value || '',
                text: option.dataset.text || '',
                option: option,
                isCustom: false,
            },
            bubbles: true, // Allow event to bubble up to document
        });
        this.container.dispatchEvent(changeEvent);

        this.forceClose();
    }

    public applyCustomQuantity(): void {
        if (!this.customInput) return;

        const value = this.customInput.value.trim();
        const quantity = parseInt(value, 10);
        const minQuantity = this.getMinimumQuantity();

        // Validate
        if (!value || isNaN(quantity) || quantity <= 0) {
            this.showError('Zadejte platné číslo');
            return;
        }

        if (quantity < minQuantity) {
            this.showError(`Minimální množství je ${minQuantity} kusů`);
            return;
        }

        // Clear selections from regular options
        this.optionElements.forEach((opt) => opt.classList.remove('selected'));

        // Store the custom quantity for future use
        this.currentCustomQuantity = quantity;

        // Calculate pricing for header display
        const pricing = this.calculatePricingForQuantity(quantity);
        if (pricing) {
            // Update display with pricing information like regular options
            const priceText = pricing.pricePerUnit > 0 ? `${pricing.pricePerUnit.toFixed(2).replace('.', ',')} Kč/ks` : 'Na vyžádání';
            const totalText = pricing.totalPrice > 0 ? `${pricing.totalPrice.toFixed(0).replace('.', ',')} Kč` : 'Na vyžádání';
            const discountText = pricing.discount > 0 ? `Ušetříte ${Math.round(pricing.discount)} %` : '';
            
            this.selectedValue.innerHTML = `<div class="selected-wrapper"><div class="selected-quantity">${quantity} ks</div><div class="selected-price">${priceText}</div>${discountText ? `<div class="selected-discount">${discountText}</div>` : ''}</div>`;
        } else {
            // Fallback to simple display
            this.selectedValue.textContent = `${quantity} kusů (vlastní)`;
        }

        // Dispatch event
        const changeEvent = new CustomEvent('pricingSelectChange', {
            detail: {
                value: quantity.toString(),
                quantity: quantity,
                text: `${quantity} kusů (vlastní)`,
                isCustom: true,
            },
            bubbles: true, // Allow event to bubble up to document
        });
        this.container.dispatchEvent(changeEvent);

        // DON'T clear input - keep the value for future editing
        this.customInput.blur(); // Remove focus from input
        this.inputIsFocused = false; // Force clear the flag
        this.forceClose(); // Use force close instead of regular close
    }

    private getMinimumQuantity(): number {
        // Use minQuantity from data if available
        if (this.quantityPricingData && this.quantityPricingData.minQuantity) {
            return this.quantityPricingData.minQuantity;
        }

        // Fallback to calculating from options
        let minQuantity = Infinity;
        
        this.optionElements.forEach((option) => {
            const value = option.dataset.value;
            if (value && value !== 'other' && value !== 'custom') {
                const quantity = parseInt(value, 10);
                if (!isNaN(quantity) && quantity < minQuantity) {
                    minQuantity = quantity;
                }
            }
        });
        
        return minQuantity === Infinity ? 1 : minQuantity;
    }

    private calculatePricingForQuantity(quantity: number): { pricePerUnit: number; discount: number; totalPrice: number } | null {
        if (!this.quantityPricingData || quantity <= 0) {
            return null;
        }

        const quantityPrices = this.quantityPricingData.quantityPrices;
        const basePrice = this.quantityPricingData.basePrice;

        // Find lowest tier
        let lowestTierQuantity = Infinity;
        for (const tier of quantityPrices) {
            if (tier.quantityFrom < lowestTierQuantity) {
                lowestTierQuantity = tier.quantityFrom;
            }
        }

        // If quantity is below lowest tier, price is "Na vyžádání" (0)
        if (quantity < lowestTierQuantity) {
            return {
                pricePerUnit: 0,
                discount: 0,
                totalPrice: 0
            };
        }

        // Check if quantity matches any defined price tier
        let applicablePrice: number | null = null;
        let foundTier = false;
        
        for (let i = quantityPrices.length - 1; i >= 0; i--) {
            const tier = quantityPrices[i];
            if (quantity >= tier.quantityFrom) {
                // Check if this tier covers the quantity (if quantityTo exists)
                if (!tier.quantityTo || quantity <= tier.quantityTo) {
                    applicablePrice = tier.price;
                    foundTier = true;
                    break;
                }
            }
        }

        // If no tier found for this quantity, it means price is "Na vyžádání" (0)
        if (!foundTier) {
            return {
                pricePerUnit: 0,
                discount: 0,
                totalPrice: 0
            };
        }

        // Calculate discount percentage
        const discount = basePrice > 0 && applicablePrice !== null ? (1 - applicablePrice / basePrice) * 100 : 0;

        // Calculate total price
        const totalPrice = applicablePrice !== null ? applicablePrice * quantity : 0;

        return {
            pricePerUnit: applicablePrice || 0,
            discount: Math.max(0, discount),
            totalPrice: totalPrice
        };
    }


    private showError(message: string): void {
        if (!this.customInput) return;
        
        this.customInput.classList.add('error');
        
        // Show error message (you can customize this based on your UI)
        this.customInput.title = message;
        
        // Optionally show an alert or tooltip
        // alert(message);
        
        setTimeout(() => {
            if (this.customInput) {
                this.customInput.classList.remove('error');
                this.customInput.title = '';
            }
        }, 3000);
    }

    private toggle(): void {
        if (this.isOpen) {
            this.forceClose();
        } else {
            this.open();
        }
    }

    private open(): void {
        this.isOpen = true;
        this.header.classList.add('active');
        this.arrow.classList.add('rotated');

        // Calculate and set dynamic height
        this.setDynamicHeight();

        this.options.classList.add('open');

        // Pre-fill input with current custom quantity if exists
        if (this.customInput && this.currentCustomQuantity !== null) {
            this.customInput.value = this.currentCustomQuantity.toString();

            // Select the text for easy editing
            setTimeout(() => {
                if (this.customInput) {
                    this.customInput.select();
                }
            }, 50);
        }

        // Set placeholder with minimum quantity hint
        if (this.customInput) {
            const minQuantity = this.getMinimumQuantity();
            this.customInput.placeholder = `Min. ${minQuantity} kusů`;
        }

        // Removed automatic focus of custom input
        // User can click on input manually if they want to use it
    }

    private setDynamicHeight(): void {
        // Temporarily show options to measure height
        this.options.style.maxHeight = 'none';
        this.options.style.visibility = 'hidden';
        this.options.style.display = 'block';

        // Get the actual content height
        const contentHeight = this.options.scrollHeight;

        // Get viewport height for limits
        const viewportHeight = window.innerHeight;
        const maxAllowedHeight = Math.min(contentHeight, viewportHeight * 0.8); // 80% of viewport

        // Check if select is near bottom of screen
        const selectRect = this.container.getBoundingClientRect();
        const spaceBelow = viewportHeight - selectRect.bottom;
        const finalHeight = Math.min(maxAllowedHeight, spaceBelow - 20); // 20px margin

        // Reset styles and set calculated height
        this.options.style.display = '';
        this.options.style.visibility = '';
        this.options.style.maxHeight = '0px';

        // Force reflow and then set the target height
        requestAnimationFrame(() => {
            this.options.style.maxHeight = `${finalHeight}px`;
        });
    }

    public close(): void {
        // Don't close if input is focused (except when forced)
        if (this.inputIsFocused) {
            return;
        }

        this.isOpen = false;
        this.header.classList.remove('active');
        this.arrow.classList.remove('rotated');
        this.options.classList.remove('open');

        // Reset max-height for next opening
        this.options.style.maxHeight = '0px';


        // Clear input only if no custom quantity is stored (i.e., user canceled without selecting)
        if (this.customInput && this.currentCustomQuantity === null) {
            this.customInput.value = '';
        }
    }

    public forceClose(): void {
        // Force close regardless of input focus state
        this.isOpen = false;
        this.inputIsFocused = false;
        this.header.classList.remove('active');
        this.arrow.classList.remove('rotated');
        this.options.classList.remove('open');

        // Reset max-height for next opening
        this.options.style.maxHeight = '0px';


        // Remove focused class from any custom input option
        const customInputOption = this.container.querySelector('.custom-input-option');
        if (customInputOption) {
            customInputOption.classList.remove('focused');
        }

        // Clear input only if no custom quantity is stored (i.e., user canceled without selecting)
        if (this.customInput && this.currentCustomQuantity === null) {
            this.customInput.value = '';
        }
    }

    // Public getters for accessing private properties
    public getContainer(): HTMLElement {
        return this.container;
    }

    public getIsOpen(): boolean {
        return this.isOpen;
    }

    public getCustomInput(): HTMLInputElement | null {
        return this.customInput;
    }

    public destroy(): void {
        this.header.removeEventListener('click', this.handleHeaderClick);
        // Remove other listeners as needed
    }
}

// Main export combining both components
export default class CustomCartSelect {
    static init(): void {
        SimpleCartSelect.init();
        PricingCartSelect.init();
    }

    static destroy(): void {
        PricingCartSelect.destroy();
        // SimpleCartSelect doesn't have destroy method in original
    }
}
